export const TYPE = {
  0: 'Binocular',
  1: 'Monocular derecho',
  2: 'Monocular izquierdo'
}
